import producer from "immer";
import { getSessionStorageKey, setSessionStorageKey } from "../../../utils";

const INITIAL_STATE = {
	loading: true,
	disable_button: false,
	plan: getSessionStorageKey("PLANSELECTED") || null,
	isAddressValid: getSessionStorageKey("ISADDRESSVALID") || false,
	listPlan: getSessionStorageKey("LISTPLAN") || [],
	listResearch: getSessionStorageKey("LISTRESEARCH") || [],
	research: getSessionStorageKey("RESEARCHSELECTED") || null,
	payment_mode: getSessionStorageKey("PAYMENT_MODE") || [],
	payment_mode_selected: getSessionStorageKey("PAYMENT_MODE_SELECTED") || null,
	payment_result: getSessionStorageKey("RESULT_DOPAYMENT") || null,
	cd_recurrence: "A",
	onscroll: false,
	eleven_plan_investor_data: getSessionStorageKey("INFOELEVENINVESTOR") || null,
	id_league: null,
	cod_campaign: null,
	redirect_path: null,
	campaign: localStorage.getItem("CAMPAIGN") || null,
	id_research: localStorage.getItem("IDRESEARCH") || null,
	cd_promotional: sessionStorage.getItem("CDPROMOTIONAL") || null,
	qtt_installments: null,
	installment_options: null,
	dataMicroServiceFluxPromo: null,
	dataPlanFluxPromo: null,
	isFluxPromotional: false,
	productSelected: [],
};

export default function billingPlan(state = INITIAL_STATE, action) {
	const ACTIONS = {
		"@billingPlan/INSTALLMENT_OPTIONS": (draft) => {
			draft.installment_options = action.payload.installment_options;
		},
		"@billingPlan/SET_CD_PROMOTIONAL": (draft) => {
			const { cd_promotional } = action.payload;
			Boolean(cd_promotional)
				? sessionStorage.setItem("CDPROMOTIONAL", cd_promotional)
				: sessionStorage.removeItem("CDPROMOTIONAL");
			draft.cd_promotional = cd_promotional;
		},
		"@billingPlan/QTT_INSTALLMENTS": (draft) => {
			draft.qtt_installments = action.payload.qtt_installments;
		},
		"@billingPlan/CHANGE_SCROLL": (draft) => {
			draft.onscroll = action.payload.onscroll;
		},
		"@billingPlan/CHANGE_LOADING": (draft) => {
			draft.loading = action.payload.loading;
		},
		"@billingPlan/SELECTED_PLAN_SUCCESS": (draft) => {
			const plan = action.payload.plan;
			setSessionStorageKey("PLANSELECTED", plan);
			draft.plan = plan;
		},
		"@billingPlan/SELECTED_RESEARCH_SUCCESS": (draft) => {
			draft.research = action.payload.research;
		},
		"@billingPlan/VALID_ADDRESS_USER_SUCCESS": (draft) => {
			draft.isAddressValid = action.payload.isAddressValid;
		},
		"@billingPlan/ON_GET_RESEARCH_BY_PLAN_SUCCESS": (draft) => {
			draft.research = action.payload.listResearch[action.payload.planTitle].length
				? action.payload.listResearch[action.payload.planTitle][0]
				: null;
			draft.listResearch = action.payload.listResearch;
		},
		"@billingPlan/ON_GET_BILLING_PLAN_BY_CD_SUCCESS": (draft) => {
			const plan = action.payload.plan;
			setSessionStorageKey("PLANSELECTED", plan);
			draft.plan = plan;
		},
		"@billingPlan/ON_GET_PAYMENT_MODE_SUCCESS": (draft) => {
			const payment_mode = action.payload.payment_mode;
			setSessionStorageKey("PAYMENT_MODE", payment_mode);
			draft.payment_mode = payment_mode;
		},
		"@billingPlan/SELECTED_PAYMENT_MODE": (draft) => {
			const payment_mode_selected = action.payload.payment_mode_selected;
			setSessionStorageKey("PAYMENT_MODE_SELECTED", payment_mode_selected);
			draft.payment_mode_selected = payment_mode_selected;
		},
		"@billingPlan/PROCESS_RESULT_DO_PAYMENT": (draft) => {
			const payment_result = action.payload.result;
			setSessionStorageKey("RESULT_DOPAYMENT", payment_result);
			draft.disable_button = false;
			draft.payment_result = payment_result;
		},
		"@billingPlan/DISABLE_BUTTON": (draft) => {
			draft.disable_button = action.payload.disable_button;
		},
		"@billingPlan/ON_GET_BILLING_PLAN_SUCCESS": (draft) => {
			const listPlan = action.payload.listPlan;
			setSessionStorageKey("LISTPLAN", listPlan);
			draft.listPlan = listPlan;
		},
		"@billingPlan/CLEAN_PLAN_REQUEST": (draft) => {
			draft.plan = null;
		},
		"@billingPlan/CHANGE_CD_RECURRENCE_SUCCESS": (draft) => {
			draft.cd_recurrence = action.payload.cd_recurrence;
		},
		"@billingPlan/INFO_ELEVEN_PLAN_INVESTOR_DATA": (draft) => {
			let investor_data = action.payload.data;
			setSessionStorageKey("INFOELEVENINVESTOR", investor_data);
			draft.eleven_plan_investor_data = investor_data;
		},
		"@billingPlan/SET_ID_RESEARCH": (draft) => {
			let { id_research } = action.payload;
			draft.id_research = id_research;
			Boolean(id_research)
				? localStorage.setItem("IDRESEARCH", id_research)
				: localStorage.removeItem("IDRESEARCH");
		},
		"@billingPlan/SET_PARAM_ROUTE": (draft) => {
			let { id_league, cod_campaign, cd_plan, id_research, campaign } = action.payload;
			const queryParams = new URLSearchParams(window.location.search);
			const redirect_path = queryParams.get("redirect_path");

			Boolean(id_league)
				? localStorage.setItem("IDLEAGUE", id_league)
				: localStorage.removeItem("IDLEAGUE");
			Boolean(cod_campaign)
				? localStorage.setItem("CODCAMPAIGN", cod_campaign)
				: localStorage.removeItem("CODCAMPAIGN");
			Boolean(cd_plan)
				? localStorage.setItem("CDPLAN", cd_plan)
				: localStorage.removeItem("CDPLAN");
			Boolean(id_research)
				? localStorage.setItem("IDRESEARCH", id_research)
				: localStorage.removeItem("IDRESEARCH");
			Boolean(campaign)
				? localStorage.setItem("CAMPAIGN", campaign)
				: localStorage.removeItem("CAMPAIGN");
			Boolean(redirect_path)
				? localStorage.setItem("REDIRECTPATH", redirect_path)
				: localStorage.removeItem("REDIRECTPATH");
			draft.id_league = id_league;
			draft.cod_campaign = cod_campaign;
			draft.cd_plan = cd_plan;
			draft.id_research = id_research;
			draft.campaign = campaign;
			draft.redirect_path = redirect_path;
		},
		"@billingPlan/RESPONSE_MICRO_SERVICE_FLUX_PROMO": (draft) => {
			draft.dataMicroServiceFluxPromo = action.payload.param;
		},
		"@billingPlan/RESPONSE_PLAN_FLUX_PROMO": (draft) => {
			draft.dataPlanFluxPromo = action.payload.param;
		},
		"@billingPlan/SET_FLUX_PROMOTIONAL": (draft) => {
			draft.isFluxPromotional = action.payload.param;
		},
		"@billingPlan/SET_PRODUCT_FOR_CHECKOUT": (draft) => {
			draft.productSelected = action.payload.param;

			const actionProduct = {
				plan: () => {
					setSessionStorageKey("PLANSELECTED", action.payload.param);
					setSessionStorageKey("PROMOTIONAL_FLOW", true);
				},
				micro_service: () => {
					setSessionStorageKey("PROMOTIONAL_FLOW", true);
					setSessionStorageKey("COMBO_PROMOTIONAL_FLOW", action.payload.param);

					if (action.payload.param && !action.payload.param.length) {
						sessionStorage.removeItem("COMBO_PROMOTIONAL_FLOW");
					}
				},
			};

			actionProduct[action.payload.product]();
		},
	};

	return producer(state, (draft) => {
		return Object.keys(ACTIONS).indexOf(action.type) !== -1 ? ACTIONS[action.type](draft) : state;
	});
}
